import { loginUser, savePrevPath } from 'actions'
import store from 'main/store'
import dashboardApi from 'services/api/dashboard'
import LocalUserService from 'services/localUserService'
import { getSavedSubsidiary } from 'utils/helpers'

export async function sessionExpiredHandler() {
  const userService = new LocalUserService()

  const isSessionTimedOut = store.getState().login.sessionTimedOut
  const isSessionExpired = store.getState().login.sessionExpired

  if (isSessionExpired || isSessionTimedOut) {
    return // nothing to handle
  }

  const location = window.location
  const pathname = window.location.pathname

  store.dispatch({ type: 'SESSION_TIMED_OUT' })

  if (!pathname.includes('/login') && !pathname.includes('selectHotel')) {
    store.dispatch(savePrevPath(`${location.pathname}${location.search}`))
  }

  const currentUserInfo = userService.getCurrentUserInfo()

  const lastGeoLocation = store.getState().signIn.geoLocation
  const subsidiaryId = store.getState().login.currentHotelId

  try {
    const savedSubsidiaryId = getSavedSubsidiary().subsidiaryId
    const uiSubsidiaryId = subsidiaryId || savedSubsidiaryId

    const additionalData = {
      uiDashboardSessionId: currentUserInfo.sessionId,
      uiUserName: currentUserInfo?.user?.name,
      uiPath: document.location.pathname,
      uiGeolocation: JSON.stringify(lastGeoLocation),
      uiScreenResolution: `${window.screen.width}x${window.screen.height}`,
      uiSubsidiaryId
    }

    if (!uiSubsidiaryId) {
      console.warn("couldn't renew session, no subsidiaryId")

      await dashboardApi.log({
        level: 'Debug',
        message: `Not renewing session since subsidiaryId is destroyed`,
        additionalData
      })

      store.dispatch({ type: 'EXPIRE_SESSION' })
      return
    }

    await dashboardApi.log({
      level: 'Debug',
      message: `Will try to renew session for sessionId: ${currentUserInfo.sessionId}`,
      additionalData,
      rawData: JSON.stringify(getSavedSubsidiary())
    })

    const sessionRenewResponse = await dashboardApi.renewSession({
      sessionId: currentUserInfo.sessionId,
      userToken: currentUserInfo.userToken,
      geoLocation: lastGeoLocation,
      screen: `${window.screen.width}x${window.screen.height}`,
      subsidiaryId: subsidiaryId || savedSubsidiaryId
    })

    await dashboardApi.log({
      level: 'Debug',
      message: `Got renew session response: isSuccess ${sessionRenewResponse.isSuccess}`,
      additionalData
    })

    if (sessionRenewResponse.isSuccess) {
      userService.updateSessionInfo(
        sessionRenewResponse.result.sessionId,
        sessionRenewResponse.result.userToken
      )
      // Notify Electron of updated token
      if (window?.electron?.postMessage) {
        window.electron.postMessage({
          type: 'token-updated',
          data: {
            spAuth: sessionRenewResponse.result.sessionId
          }
        })
      }
      store.dispatch({
        type: 'SESSION_RENEWED',
        payload: sessionRenewResponse.result.sessionId
      })
      store.dispatch(
        loginUser(
          currentUserInfo.user,
          sessionRenewResponse.result.userToken,
          sessionRenewResponse.result.userId,
          sessionRenewResponse.result.sessionId
        )
      )
    } else {
      store.dispatch({ type: 'EXPIRE_SESSION' })
      console.warn("couldn't renew session", sessionRenewResponse)
    }
  } catch (error) {
    await dashboardApi.log({
      level: 'Error',
      message: `Couldn't renew session`,
      additionalData: {
        uiGeolocation: JSON.stringify(lastGeoLocation),
        uiPath: document.location.pathname,
        uiUserName: currentUserInfo?.user?.name,
        uiDashboardSessionId: currentUserInfo?.sessionId,
        uiScreenResolution: `${window.screen.width}x${window.screen.height}`
      }
    })

    console.warn("couldn't renew session", error)
    store.dispatch({ type: 'EXPIRE_SESSION' })

    if (window?.electron?.postMessage) {
      window.electron.postMessage({
        type: 'logged-out',
        data: {
          subsidiaryId
        }
      })
    }
  }
}
